<ion-card *cdkVirtualFor="let card of productsData; let i = index">
  <app-non-usf-product-card
    [productData]="card"
    [platform]="platform"
    (selectEvent)="handleSelect($event)"
    (productNameClickEvent)="handleNameClick($event)"
  ></app-non-usf-product-card>
</ion-card>
